/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { CBQLectureExam } from "./cbqStudentTypes";

type GetCBQByLectureResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CBQLectureExam[];
};

// GET /cbq/lectures/:lectureId/exams — list of CBQ exams attached to a lecture
// (each with publish state + the student's attempt summary). Handles a flat
// array or a paginated { data: [] } shape.
export const GetCBQByLecture = async (
  lectureId: string
): Promise<GetCBQByLectureResponse> => {
  try {
    const response = await axios.get(`/cbq/lectures/${lectureId}/exams`);
    const raw = response.data?.data ?? response.data;
    const list: CBQLectureExam[] = Array.isArray(raw) ? raw : raw?.data ?? [];
    return { data: list };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      if (error.response.status === 404) {
        return { data: [] };
      }
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
